(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-media-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bd-media-carousel')) {
    class BdMediaCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.viewport = this.querySelector('[data-bd-carousel-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-bd-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-bd-carousel-dot]'));
        this.previousButton = this.querySelector('[data-bd-carousel-previous]');
        this.nextButton = this.querySelector('[data-bd-carousel-next]');
        this.status = this.querySelector('[data-bd-carousel-status]');
        this.activeIndex = 0;
        this.pendingIndex = null;
        this.userInitiated = false;
        this.scrollFrame = 0;
        this.hoverToNext = this.dataset.hoverToNext === 'true';
        this.hoverPointerMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
        this.reduceMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

        // De waarnemer pas scherpstellen na de eerste scroll (of na 6 s). Tijdens het
        // laden klopt de opmaak nog niet en vuurt hij voor secties die in werkelijkheid
        // duizenden pixels lager staan; dan haalt hij hun foto's alsnog binnen.
        if (document.readyState === 'complete') this.bdArmLazy();
        else window.addEventListener('load', () => this.bdArmLazy(), { once: true });

        if (!this.viewport || this.slides.length < 2) {
          this.dataset.ready = 'true';
          return;
        }

        this.onScroll = this.handleScroll.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.onResize = this.handleResize.bind(this);
        this.onPreviousClick = () => this.goTo(this.activeIndex - 1, true);
        this.onNextClick = () => this.goTo(this.activeIndex + 1, true);
        this.onPointerDown = () => {
          this.pendingIndex = null;
          this.userInitiated = true;
        };
        this.onPointerEnter = () => {
          if (!this.hoverToNext || !this.hoverPointerMedia.matches || this.reduceMotionMedia.matches) return;
          if (this.activeIndex >= this.slides.length - 1) return;
          const nextIndex = this.activeIndex + 1;
          this.goTo(nextIndex, false);
        };
        this.dotClickHandlers = this.dots.map((dot) => () => this.goTo(Number(dot.dataset.index), true));

        this.previousButton.addEventListener('click', this.onPreviousClick);
        this.nextButton.addEventListener('click', this.onNextClick);
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', this.dotClickHandlers[index]);
        });

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKeydown);
        this.viewport.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.viewport.addEventListener('pointerenter', this.onPointerEnter, { passive: true });
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
        this.update(0, false);
        this.dataset.ready = 'true';
      }

      /* V37: een slide haalt zijn afbeelding pas op als de carousel in beeld komt
         of als de bezoeker naar die slide klikt. Zonder dit haalt Chrome op een
         trage verbinding alle slides van de hele pagina alvast binnen. */
      bdLoadSlide(index) {
        const slide = this.slides && this.slides[index];
        if (!slide) return;
        slide.querySelectorAll('[data-bd-srcset]').forEach((el) => {
          el.setAttribute('srcset', el.getAttribute('data-bd-srcset'));
          el.removeAttribute('data-bd-srcset');
        });
        slide.querySelectorAll('img[data-bd-src]').forEach((el) => {
          // op dit moment is de afbeelding echt nodig: uit de lazy-wachtrij halen,
          // anders start een <img> in een <picture> die bij het parsen nog geen
          // bron had de download niet meer.
          el.loading = 'eager';
          el.removeAttribute('fetchpriority');
          el.setAttribute('src', el.getAttribute('data-bd-src'));
          el.removeAttribute('data-bd-src');
        });
      }

      bdLoadAll() {
        if (!this.slides) return;
        this.slides.forEach((slide, index) => this.bdLoadSlide(index));
      }

      bdArmLazy() {
        if (this.bdArmed) return;
        this.bdArmed = true;
        const start = () => {
          if (this.bdStarted) return;
          this.bdStarted = true;
          window.removeEventListener('scroll', start);
          if (this.bdArmTimer) window.clearTimeout(this.bdArmTimer);
          this.bdSetupLazy();
        };
        window.addEventListener('scroll', start, { passive: true });
        this.bdArmTimer = window.setTimeout(start, 6000);
      }

      bdSetupLazy() {
        if (!this.slides || !this.slides.length) return;
        if (!('IntersectionObserver' in window)) {
          this.bdLoadAll();
          return;
        }
        this.bdObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.bdLoadSlide(this.activeIndex || 0);
            if (this.bdFallbackTimer) { window.clearTimeout(this.bdFallbackTimer); this.bdFallbackTimer = 0; }
            if (this.bdObserver) {
              this.bdObserver.disconnect();
              this.bdObserver = null;
            }
            break;
          }
        }, { rootMargin: '600px 0px', threshold: 0 });
        this.bdObserver.observe(this);

        // Vangnet: als de waarnemer om welke reden dan ook niet afgaat (verborgen
        // tabblad, oudere browser, een pagina die nooit schuift), laden we de
        // zichtbare slide na vier seconden alsnog. Liever een late foto dan geen.
        this.bdFallbackTimer = window.setTimeout(() => {
          if (!this.bdObserver) return;
          this.bdLoadSlide(this.activeIndex || 0);
          this.bdObserver.disconnect();
          this.bdObserver = null;
        }, 4000);
      }

      disconnectedCallback() {
        if (!this.viewport) return;
        if (this.slides.length < 2 || !this.onScroll) {
          delete this.dataset.ready;
          return;
        }
        this.viewport.removeEventListener('scroll', this.onScroll);
        this.viewport.removeEventListener('keydown', this.onKeydown);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointerenter', this.onPointerEnter);
        this.previousButton.removeEventListener('click', this.onPreviousClick);
        this.nextButton.removeEventListener('click', this.onNextClick);
        this.dots.forEach((dot, index) => {
          dot.removeEventListener('click', this.dotClickHandlers[index]);
        });
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.bdArmTimer) { window.clearTimeout(this.bdArmTimer); this.bdArmTimer = 0; }
        if (this.bdFallbackTimer) { window.clearTimeout(this.bdFallbackTimer); this.bdFallbackTimer = 0; }
        if (this.bdObserver) { this.bdObserver.disconnect(); this.bdObserver = null; }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        delete this.dataset.ready;
      }

      handleScroll() {
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => {
          const width = this.viewport.clientWidth || 1;
          if (this.pendingIndex !== null) {
            const expectedLeft = this.pendingIndex * width;
            if (Math.abs(this.viewport.scrollLeft - expectedLeft) <= 4) {
              const settledIndex = this.pendingIndex;
              this.pendingIndex = null;
              this.update(settledIndex, false);
            }
            return;
          }
          const index = Math.round(this.viewport.scrollLeft / width);
          this.update(index, this.userInitiated);
        });
      }

      handleKeydown(event) {
        let nextIndex = null;
        if (event.key === 'ArrowLeft') nextIndex = this.activeIndex - 1;
        if (event.key === 'ArrowRight') nextIndex = this.activeIndex + 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.slides.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        this.goTo(nextIndex, true);
      }

      handleBlockSelect(event) {
        const slide = event.target.closest('[data-bd-carousel-slide]');
        if (!slide || !this.contains(slide)) return;
        this.goTo(this.slides.indexOf(slide), false);
      }

      handleResize() {
        this.viewport.scrollTo({ left: this.activeIndex * this.viewport.clientWidth, behavior: 'auto' });
      }

      goTo(index, announce) {
        const clampedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const targetLeft = clampedIndex * this.viewport.clientWidth;
        if (clampedIndex === this.activeIndex && Math.abs(this.viewport.scrollLeft - targetLeft) <= 4) {
          this.pendingIndex = null;
          this.update(clampedIndex, false);
          return;
        }
        this.pendingIndex = clampedIndex;
        this.userInitiated = announce;
        this.viewport.scrollTo({
          left: clampedIndex * this.viewport.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth'
        });
        this.update(clampedIndex, announce);
      }

      update(index, announce) {
        const clampedIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const changed = clampedIndex !== this.activeIndex;
        this.activeIndex = clampedIndex;
        // niet bij de eerste update() in connectedCallback: dan zou elke carousel
        // op de pagina zijn eerste foto meteen ophalen. dataset.ready wordt pas
        // daarna gezet, dus dit laadt alleen bij een echte wissel.
        if (this.dataset.ready === 'true') this.bdLoadSlide(clampedIndex);

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === clampedIndex ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === clampedIndex;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.previousButton.disabled = clampedIndex === 0;
        this.nextButton.disabled = clampedIndex === this.slides.length - 1;

        if (announce && changed && this.status) {
          this.status.textContent = `${clampedIndex + 1} ${this.dataset.ofLabel || 'of'} ${this.slides.length}`;
        }
      }
    }

    customElements.define('bd-media-carousel', BdMediaCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
